import get from 'lodash/get'

export const NO_USER_MESSAGE = 'No Layers user is linked to the Microsoft account'
export const NO_USER_ADVICE = 'Sign in with another Microsoft account or contact support.'
export const SERVER_ERROR_MESSAGE = 'An error occurred from the server. Please try again'
// Long enough to read an address and act on it (notifications default to 4 s).
export const NO_USER_NOTIFICATION_DURATION = 10000

const httpStatus = error => {
  const match = /status: (\d+)/.exec(get(error, 'message') || '')
  return match ? Number(match[1]) : null
}

// The platform answers the token exchange with 401 {"error":"No user found"} when neither the UPN nor
// the mailbox address of the signed-in Entra account belongs to a platform user — and, indistinguishably
// from here, when Graph rejected the token. Anything else is a server or network failure.
export const isNoUserError = error => httpStatus(error) === 401 || get(error, ['response', 'error']) === 'No user found'

// The UPN is what the platform looks up first, so it is the address the person is shown: the account
// the browser signed them in as, which is the thing to change.
const accountAddress = account => get(account, 'username') || get(account, ['idTokenClaims', 'email']) || get(account, 'name') || '?'

// The notification for a failed token-to-session exchange. Two translated sentences around the address
// (the translation files carry no placeholders).
export const azureLoginFailureMessage = ({ error, account, t }) =>
  isNoUserError(error) ? `${t(NO_USER_MESSAGE)}: ${accountAddress(account)}. ${t(NO_USER_ADVICE)}` : t(SERVER_ERROR_MESSAGE)
